/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";

export function ActionsColumnFormatter(
  cellContent,
  row,
  rowIndex,
  { openRoomsDialog, openEditSpecificationDialog, openDeleteSpecificationDialog, openRecoverDeleteSpecificationDialog,
    showRoomsAction, haveEditAction, haveDeleteAction }
) {
  return (
    <>
      {showRoomsAction &&
        <OverlayTrigger
          overlay={
            <Tooltip id="spec-delete-tooltip">اتاق ها</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm"
            onClick={() => openRoomsDialog(row.id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Home.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      }
      <> </>
      {haveEditAction &&
        <OverlayTrigger
          overlay={<Tooltip id="objects-edit-tooltip">ویرایش</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => openEditSpecificationDialog(row.id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>
      }

      <> </>
      {!row.isDeleted && haveDeleteAction && <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">غیرفعالسازی</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm"
          onClick={() => openDeleteSpecificationDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>}
      {row.isDeleted && haveDeleteAction && <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">فعالسازی</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-success btn-sm"
          onClick={() => openRecoverDeleteSpecificationDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-success">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Update.svg")} />
          </span>
        </a>
      </OverlayTrigger>}
      {/* {haveDeleteAction &&
        <OverlayTrigger
        overlay={<Tooltip id="objects-delete-tooltip">حذف</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={() => openDeleteSpecificationDialog(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>
} */}
    </>
  );
}
